<div class="import-intro po-mb-3" [style.display]="fileList.length > 0 ? 'none' : ''">
  <p class="import-intro-text">
    Selecione um ou mais arquivos <b class="text-green">.xlsx</b> ou <b class="text-green">.csv</b> para realizar o processamento.
    O nome do arquivo deve conter o código da tabela, com ou sem colchetes: <b class="text-green">[JC83XX]</b> ou <b class="text-green">JC83XX</b>.
  </p>
</div>

<div class="po-row po-mb-3" [style.display]="fileList.length > 0 ? 'none' : ''">
  <div class="po-lg-12">
    <po-upload
      #upload
      [p-restrictions]="restrictions"
      p-size="medium"
      [p-drag-drop]="true"
      [p-multiple]="true"
      [p-drag-drop-height]="120"
      [p-url]="urlPlaceholder"
      [p-hide-send-button]="true">
    </po-upload>
  </div>
</div>

<div class="po-row po-mb-3" *ngIf="fileList.length > 0">
  <div class="po-lg-12">
    <div *ngFor="let file of fileList" class="upload-file-card">
      <div class="upload-file-card-header">
        <span class="upload-file-card-name">{{ file.name }} - {{ file.size }}</span>
        <span class="upload-file-card-status"
          [ngClass]="{
            'status-uploading': fileStatus.get(file.name) === 'uploading',
            'status-processing': fileStatus.get(file.name) === 'processing',
            'status-success': fileStatus.get(file.name) === 'success',
            'status-error': fileStatus.get(file.name) === 'error'
          }">
          <ng-container [ngSwitch]="fileStatus.get(file.name)">
            <ng-container *ngSwitchCase="'uploading'">{{ fileProgress.get(file.name) || 0 }}%</ng-container>
            <ng-container *ngSwitchCase="'processing'">Processando dados...</ng-container>
            <ng-container *ngSwitchCase="'success'">Concluído ✓</ng-container>
            <ng-container *ngSwitchCase="'error'">Erro ✗</ng-container>
          </ng-container>
        </span>
      </div>
      <div class="upload-bar-track">
        <div class="upload-bar-fill"
          [style.width.%]="fileProgress.get(file.name) || 0"
          [ngClass]="{
            'bar-processing': fileStatus.get(file.name) === 'processing',
            'bar-success': fileStatus.get(file.name) === 'success',
            'bar-error': fileStatus.get(file.name) === 'error'
          }">
        </div>
      </div>
    </div>
  </div>
</div>

<div class="po-row po-mb-2" [style.display]="fileList.length > 0 ? 'none' : ''">
  <div class="po-lg-12">
    <po-checkbox
      name="checkbox"
      p-label="Limpar base de dados antes de importar"
      [(ngModel)]="checkbox">
    </po-checkbox>
  </div>
</div>

<div class="po-row" [style.display]="fileList.length > 0 ? 'none' : ''">
  <div class="po-lg-12">
    <po-button
      p-icon="an an-upload-simple"
      p-label="Enviar Arquivos"
      p-kind="primary"
      [p-disabled]="loading"
      [p-loading]="loading"
      (p-click)="sendArquivos()">
    </po-button>
  </div>
</div>
